import { Outlet } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { selectFeatureFlag } from '@/store/slices/feature-flags/selectors';
import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';
import ComingSoon from '@/micros/coming-soon/coming-soon';
import MainContentWrapper from '../../../../shared-create-and-edit-components/grid-areas/main/project-overview/main-content-wrapper';

export default function AudiencesRouteGate() {
  const audiencesEnabled = useAppSelector(selectFeatureFlag(FeatureFlagsEnum.audiences_enabled));
  return (
    <MainContentWrapper>{(audiencesEnabled && <Outlet />) || <ComingSoon label="Audiences" />}</MainContentWrapper>
  );
}
